import { useTheme, useMediaQuery, Box } from "@mui/material"
import React, { ReactElement } from "react"
import { useBoolean } from "src/hooks/useBoolean"
import { useGetBoostedFarms } from "src/hooks/BoostFarming/useFarmBoostContract"
import useTotalVault from "src/hooks/BoostFarming/useTotalVault"
import { getChainId } from "src/utils"
import { POOLS_MAP, Pool } from "src/constants"

import Text from "../Text"
import QuestionHelper from "../QuestionHelper"
import PoolSelectModal from "./PoolSelectModal"
import { BoostedPool } from "./PoolItem"

export default function SelectBoostPool(): ReactElement {
  const theme = useTheme()
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"))
  const chainId = getChainId()
  const totalVault = useTotalVault()
  const enable = totalVault.gt(0)
  const [showModal, openModal, closeModal] = useBoolean(false)
  const { data: boostedPoolIds } = useGetBoostedFarms()
  const poolList: Pool[] = Object.values(POOLS_MAP).filter(
    ({ addresses, rewardPids }) =>
      chainId &&
      addresses[chainId] &&
      rewardPids[chainId] &&
      boostedPoolIds?.includes(rewardPids[chainId] as number),
  )
  return (
    <Box flex={1} width={isMdDown ? "100%" : ""}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb="4px"
      >
        <Box alignItems="center" display="flex">
          <Text color="dim" size="micro">
            Boosted Pool (Max: 2 Pools)
          </Text>
          <QuestionHelper
            text="Boosted Pools are the liquidity pools with higher APR% enabled by your xFER and NFT staking."
            ml="4px"
          />
        </Box>
        <Text
          bold
          size="small"
          color="#009BE0"
          sx={{
            opacity: enable ? 1 : 0.5,
            cursor: enable ? "pointer" : "not-allowed",
          }}
          onClick={() => {
            if (enable) openModal()
          }}
        >
          {poolList.length > 0 ? "Manage" : "Select Pools"}
        </Text>
      </Box>
      <Box display="flex" flexDirection="column" gap={0.5}>
        {poolList.length > 0 ? (
          poolList.map((pool) => (
            <BoostedPool key={pool.name} poolName={pool.name} />
          ))
        ) : (
          <Text>
            {enable ? "No pool boosted yet" : "Get boost power first"}
          </Text>
        )}
      </Box>
      <PoolSelectModal open={showModal} onClose={closeModal} />
    </Box>
  )
}
